import { shareColumnsExtend, shareFormColumnsExtend } from './share';

const entityColumns = {
  id: {
    model_name: 'Notification',
    column_type: 'id',
    label_key_path: 'notification.id',
  },
  created_at: {
    model_name: 'Notification',
    column_type: 'datetime',
    label_key_path: 'notification.createdAt',
  },
  updated_at: {
    model_name: 'Notification',
    column_type: 'datetime',
    label_key_path: 'notification.updatedAt',
  },
  event: {
    model_name: 'Notification',
    column_type: 'string',
    label_key_path: 'notification.event',
  },
  target_type: {
    model_name: 'Notification',
    column_type: 'string',
    label_key_path: 'notification.targetType',
  },
  is_read: {
    model_name: 'Notification',
    column_type: 'boolean',
    label_key_path: 'notification.isRead',
  },
  title: {
    model_name: 'Notification',
    column_type: 'string',
    label_key_path: 'notification.title',
  },
  content: {
    model_name: 'Notification',
    column_type: 'text',
    label_key_path: 'notification.content',
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(entityColumns, columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(entityColumns, columns, { formColumnsConfig, type, data })
}
